
export default {
    methods:{
        goPage(){
            this.$router.go(-1);
        }
    }
}
